import React from 'react';
import { motion } from 'framer-motion';
import { ExternalLink } from 'lucide-react';
import { SlideLayout } from './SlideLayout';
import { caseStudies } from '../../data/caseStudies';
export function Slide5_Proof() {
  return <SlideLayout data-id="element-1578" data-mp="16bzbq381ngbv">
      <div className="flex flex-col h-full justify-center gap-[clamp(1rem,2.5vh,2rem)]" data-id="element-1579" data-mp="16cilgwnjiyet">
        <h2 className="text-center font-bold text-white leading-tight text-[clamp(1.75rem,3.4vw,3rem)]" data-id="element-1580" data-mp="11iwixxb3cawq">
          Real companies, <span className="text-[#7FE0C3]" data-id="element-1581" data-mp="1fdyrks7boed8">real results.</span>
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-[clamp(0.75rem,1.2vw,1.5rem)]" data-id="element-1582" data-mp="1ac9fd98d5unk">
          {caseStudies.map((study, idx) => <motion.article key={`${study.vertical} ${study.market}`} initial={{
          opacity: 0,
          y: 12
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.05 + idx * 0.03,
          duration: 0.25
        }} whileHover={{
          scale: 1.08
        }} className="relative bg-slate-900/40 border border-slate-800 rounded-xl p-[clamp(1rem,1.4vw,1.6rem)] flex flex-col transition-[border-color,box-shadow,z-index] duration-200 ease-out hover:z-10 hover:border-[#7FE0C3]/50 hover:bg-slate-900/80 hover:shadow-[0_20px_60px_rgba(0,0,0,0.5)]" style={{
          transitionTimingFunction: 'cubic-bezier(0.23, 1, 0.32, 1)'
        }} data-id="element-1583" data-mp="1kafj7wdqdav2" data-mpi={idx}>
              <h3 className="font-bold text-white leading-snug text-[clamp(1.05rem,1.25vw,1.45rem)]" data-id="element-1584" data-mp="dtebzaxvhafq">
                {study.vertical}
              </h3>
              <p className="mt-1 font-semibold uppercase tracking-wider text-[#7FE0C3] text-[clamp(0.7rem,0.8vw,0.9rem)]" data-id="element-1585" data-mp="ivdhaqd6ahfb">
                {study.market}
              </p>
              <p className="mt-3 text-slate-400 leading-snug text-[clamp(0.85rem,0.95vw,1.05rem)]" data-id="element-1586" data-mp="rtfo5mjl84ai">
                {study.summary}
              </p>

              <dl className="mt-auto pt-[clamp(0.9rem,1.2vw,1.35rem)] border-t border-slate-800 space-y-[clamp(0.35rem,0.6vh,0.65rem)]" data-id="element-1587" data-mp="2tl25sxhlamub">
                {study.stats.map(stat => <div key={stat.label} className="flex items-baseline justify-between gap-2 h-[clamp(1.15rem,1.5vw,1.6rem)]" data-id="element-1588" data-mp="3rxekr8b9up6w">
                    <dt className="uppercase tracking-wider text-slate-500 whitespace-nowrap overflow-hidden text-ellipsis text-[clamp(0.68rem,0.78vw,0.85rem)]" data-id="element-1589" data-mp="9pfcnkuloyb6">
                      {stat.label}
                    </dt>
                    <dd className="font-bold text-white whitespace-nowrap text-[clamp(1rem,1.15vw,1.3rem)]" data-id="element-1590" data-mp="er4qf897jq2y">
                      {stat.value}
                    </dd>
                  </div>)}
              </dl>
            </motion.article>)}
        </div>

        <div className="flex justify-center" data-id="element-1591" data-mp="12gguxutlb9yx">
          <a href="https://d2dhire.com/case-studies" target="_blank" rel="noopener noreferrer" className="inline-flex items-center px-6 py-3 bg-amber-500 hover:bg-amber-600 text-slate-950 font-bold rounded-lg transition-colors duration-150 ease-out" data-id="element-1592" data-mp="12h8qx6r3n9pq">
            <span data-id="element-1593" data-mp="1m1qtvtv9s2sp">Case Studies and Testimonials</span>
            <ExternalLink className="ml-2 w-4 h-4" data-id="element-1594" data-mp="1758edwg4ywns" />
          </a>
        </div>
      </div>
    </SlideLayout>;
}